export default "__VITE_ASSET__f9793189__"